/**
 * Homepage Banner Notification Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders Homepgae Banner notification 
 */
import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { SVBTypography, SVBButton, SVBTextLink } from '@svb/svb-react-components';
import Loading from "@svb/api-loading-component/dist/components/index";
// import { Utils } from '@svb/api-content-component';
import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { useCookies } from 'react-cookie';
import error from '@svb/svbbranding/dist/assets/icons/Error.svg';
import exclamation from '@svb/svbbranding/dist/assets/icons/exclamation-circle.svg';

/**
  * HomepageBannerNotification
  * @param content: url of the Banner notification content
  * @returns HomepageBannerNotification 
  */

const HomepageBannerNotification = ({ datatestid, testMockContent, content, visible }) => {
    const [cookies, setCookie] = useCookies(['banner-notify']);
    const [loading, setLoading] = useState(true);
    // const [hidebanner, setHidebanner] = useState(true);
    const { regenTokenandBrowse } = browseAPIhandler();
    const getHomepageBannerContent = datatestid ? testMockContent : getFileContent(`${content}`,regenTokenandBrowse );

    useEffect(() => {
        if (getHomepageBannerContent.type === 'success') {
            setLoading(false)
        }
    }, [getHomepageBannerContent.response])

    if (loading) {
        return <Loading />
    }
    // Overrides BannerNotification tag from markdown and renders HomepageBannerNotificationContent 
    const HomepageBannerNotificationContent = ({ type, text, children }) => {
        return (
            visible &&
            <>
                <div className='homepage-banner bannerNotifications' >
                    <div className={`bannerNotifications__container ${type ? type : 'info'} row align-items-center justify-content-center`}>
                        <div className='col-md-9 col-xs-12 align-items-center d-flex'>
                            {type === 'error' ?
                                (
                                    <img
                                        alt="error"
                                        className="bannerNotifications__icon"
                                        src={error}
                                    />
                                ) : (
                                    <img
                                        alt="exclamation"
                                        className="bannerNotifications__icon"
                                        src={exclamation}
                                    />

                                )
                            }
                            <span className='ps-3'>{text}</span>
                        </div>
                        <div className='col-md-3 col-xs-12 text-center'>
                            {children}
                        </div>
                    </div>
                </div>
                {/* @todo update global banner notification to add classes and boostrapped */}
                {/* <SVBBannerNotification type={type ? type + ' d-flex' : null} rightContent={<ButtonGroup />}>
                    {children}
                </SVBBannerNotification> */}
            </>
        );
    }
    // Overrides ButtonGroup tag from markdown and renders ButtonGroup which wraps the buttons
    const ButtonGroup = ({ children }) => (
        <div className="banner-btn-group">
            {children}
        </div>
    );

    // handles the dismiss button click in banner
    const handleClick = (cookieExpiresIn) => {
        // setHidebanner(false); //have to store in localstorage
        cookieExpiresIn ?
            setCookie('banner-notify', 'closed', { maxAge: cookieExpiresIn }) //sets cookie for cookieExpiresIn time in seconds and then clears the cookie after that time making banner notification visible
            : setCookie('banner-notify', 'closed', { expires: 0 }) //clears cookie if browser session is closed and then banner notification is visible(might have to store in localstorage) 
    }

    // Overrides Button tag from markdown and renders BannerButton which renders the buttons
    const BannerButton = ({ action, type, text, href, external, cookieExpiresIn }) => {
        if (action === 'dismiss') {
            return (
                <SVBButton text={text} size="small" style={type} state="default" type="text" onClick={() => handleClick(cookieExpiresIn)} />
            )
        }
        else {
            return (
                <SVBButton text={<SVBTextLink external={external} href={href} type="white" text={text} />} size="small" style={type} state="default" type="text" />
            );
        }
    };
    return (
        <>
            {cookies["banner-notify"] !== "closed" &&
                <Markdown options={{
                    overrides: {
                        h3: {
                            component: SVBTypography,
                            props: {
                                type: "heading-medium",
                                variant: "homepage_hero__subheading"
                            }
                        },
                        h1: {
                            component: SVBTypography,
                            props: {
                                type: "heading-xlarge",
                                variant: "homepage_hero__heading"
                            }
                        },
                        BannerNotification: {
                            component: HomepageBannerNotificationContent,
                        },
                        ButtonGroup: {
                            component: ButtonGroup,
                        },
                        Button: {
                            component: BannerButton
                        }

                    }
                }} >{getHomepageBannerContent.response}</Markdown>
            }

        </>
    )

}
export default HomepageBannerNotification;